import { useAppSelector } from "@builder/store/store";
import { BaseLayerTypes } from "@common/build/types";
import LayerCollapse from "./LayersCollapse";
import "./LayersCollapse/style.scss";
import { useTranslation } from "react-i18next";

const Layers = () => {
    const pages = useAppSelector(state => state.builder.build.pages);
    const popups = useAppSelector(state => state.builder.build.popups);
    const cfds = useAppSelector(state => state.builder.build.cfds);
    const { t } = useTranslation();
    return (
        <>
            <LayerCollapse title="Pages" open={true} type={BaseLayerTypes.PAGES}>
                {pages}
            </LayerCollapse>
            <div className="divide" />
            <LayerCollapse title="Pop-ups" open={true} type={BaseLayerTypes.POPUPS}>
                {popups}
            </LayerCollapse>
            <div className="divide" />
            <LayerCollapse title="Customer displays" open={true} type={BaseLayerTypes.CFDS} tooltip={t("tooltip.addCFD")}>
                {cfds}
            </LayerCollapse>
        </>
    );
};

export default Layers;
